import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-00652bdc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "cell name" };
const _hoisted_2 = { class: "book-name" };
const _hoisted_3 = { class: "cell contacts" };
const _hoisted_4 = { class: "cell date" };
const _hoisted_5 = { class: "cell state" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "cell actions" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_or_card = _resolveComponent("or-card");
    return (_openBlock(), _createBlock(_component_or_card, { class: "row head-row flex !flex-row !theme-background-surface-variant dark:!theme-background-surface-variant-dark !typography-body-2-bold !text-on-background dark:!text-on-background-dark" }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('contactBooks.listHeader.bookName')), 1)
            ]),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('contactBooks.listHeader.contacts')), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('contactBooks.listHeader.dateCreated')), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('contactBooks.listHeader.sharingStatus')), 1),
            _hoisted_6
        ]),
        _: 1
    }));
}
